import { setOpportunityListIdToShowUpdatedListModal } from "app/pages/sales-intelligence/sub-modules/opportunities/store/action-creators";
import { selectOpportunityListIdToShowUpdatedListModal } from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";
import type { ComponentPropsWithoutRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OpportunityListUpdatedModal } from "./OpportunityListUpdatedModal";

type Props = Omit<ComponentPropsWithoutRef<typeof OpportunityListUpdatedModal>, "listId">;

const OpportunityListUpdatedModalContainer = (props: Props) => {
    const dispatch = useDispatch();

    const opportunityListId = useSelector(selectOpportunityListIdToShowUpdatedListModal);

    const handleCloseModal = () => {
        dispatch(setOpportunityListIdToShowUpdatedListModal(undefined));
        props.onClose?.();
    };

    return (
        <OpportunityListUpdatedModal
            {...props}
            listId={opportunityListId}
            onClose={handleCloseModal}
        />
    );
};

export default OpportunityListUpdatedModalContainer;
